import { AppConfigService } from '../../app-load/services/app-config.service';
import { HttpClient } from '@angular/common/http';
import { OAuthApi } from '@app/modules/core/api/oauth.api';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
@Injectable()
export class UserService {
  private readonly apiRoutes = {
    userInfo: (): string => `${this.endPoint}/info`
  };

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {}
  get endPoint(): string {
    return (
      this.appConfigService.getConfig().apiGatewayEndpoint + '/api/rest/v2/user'
    );
  }

  getUserInfo(): Observable<OAuthApi.UserInfo.Response> {
    return this.http.get<OAuthApi.UserInfo.Response>(this.apiRoutes.userInfo());
  }
}
